module.exports = __webpack_public_path__ + "img/icon-lawlex.22bbd6df.svg";